import toast from 'react-hot-toast';
import { createApi } from '../services'
import { useMutation, useQuery } from 'react-query'

export const useFetch = (key, api, options = { onSuccess: () => { } },) => {
  return useQuery({
    queryKey: key,
    queryFn: async () => {
      const result = await api(createApi())
      options.onSuccess && options.onSuccess(result?.data)
      return result.data;
    },
    ...options
  });
};

export const useSubmission = (key, api, options = {}) => {
  return useMutation({
    mutationKey: key,
    mutationFn: async (args) => await api(createApi(), args),
    ...options
  })
}
